import { ValidationError } from 'yup';

interface FieldError {
  type: string;
  message: string;
}

export type YupErrorResolverReturn<T> = Partial<Record<keyof T, FieldError>>;

export const yupErrorResolver = <T extends Record<string, any>>(
  errors: ValidationError,
): YupErrorResolverReturn<T> => {
  return errors.inner.reduce((acc, error) => {
    if (!error.path) return acc;

    return {
      ...acc,
      [error.path]: {
        type: error.type ?? 'validation',
        message: error.message,
      },
    };
  }, {});
};
